import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import { useUserContext } from "store/contexts/userContext";
import { useToasts } from "react-toast-notifications";
import ClickAwayListener from "react-click-away-listener";
import UserDefaultAvatar from "assets/img/user.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/CustomButton";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-responsive-modal";
import { CSSTransition } from "react-transition-group";
import { useGlobalContext } from "store/contexts/globalContext";
import { useHistory } from "react-router-dom";
import LazyLoadImage from "components/LazyLoadImage";
import SelectAdminModal from "../SelectAdminModal/SelectAdminModal";
import { Link } from "react-router-dom";

const blankMember = {
  first_name: "",
  last_name: "",
};

var styles = {
  userImageAndName: {
    display: "flex",
    alignItems: "center",
  },
  rootDropDown: {
    backgroundColor: "white",
    position: "absolute",
    top: "0px",
    left: "0px",
    transform: "translate3d(56px, -16px, 0px)",
    willChange: "transform",
    zIndex: 1,
  },
  titleDailog: {
    fontWeight: "600",
    marginBottom: "0",
  },
  headingDailog: {
    padding: "15px 0",
  },
  contentDropDown: {
    opacity: 1,
    transform: "none",
    transformOrigin: "right center",
    transition:
      "opacity 229ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 153ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    boxShadow:
      "0px 2px 1px -1px #ccc, 0px 1px 1px 0px #ccc, 0px 1px 3px 0px #ccc",
  },
  contentList: {
    paddingTop: "8px",
    paddingBottom: "8px",
    listStyle: "none",
  },
};

export default ({ member }) => {
  const classes = styles;
  const { addToast } = useToasts();
  const [showUserOptions, setShowUserOptions] = useState(false);
  const [makeAdminConfirm, setMakeAdminConfirm] = useState(false);
  const [removeMemberConfirm, setRemoveMemberConfirm] = useState(false);
  const [leaveTeamConfirm, setLeaveTeam] = useState(false);
  const [activeMember, setActiveMember] = useState(blankMember);
  const [showSelectAdminModal, setSelectAdminModal] = useState(false);
  const [changeRole, setChangeRole] = useState();
  const [superAdminLeaveTeam, setSuperAdminLeaveTeam] = useState(false);
  const [teamMember, setTeamMember] = useState(member);
  const [showDailogMessage, setShowDailogMessage] = useState();
  const [showDailogDescription, setSowDailogDescription] = useState();
  const [showDailogTitle, setShowDailogTitle] = useState();
  const { team } = useTeamContext();
  const { user } = useUserContext();
  const { deleteTeam } = useGlobalContext();
  let history = useHistory();

  const handleClickUserOptions = (event) => {
    setShowUserOptions(!showUserOptions);
  };

  const handleAdminClicked = async (currentMember, role) => {
    setActiveMember(currentMember);
    setChangeRole(role);
    if (role === 3) {
      setShowDailogMessage("Make an Admin");
      setShowDailogTitle(
        `Make ${currentMember.first_name} ${currentMember.last_name} an Admin?`
      );
      setSowDailogDescription(
        "Making this user an admin will allow access to additional functions."
      );
      setMakeAdminConfirm(true);
      return;
    }
    setShowDailogTitle(
      `Remove ${currentMember.first_name} ${currentMember.last_name} from an Admin?`
    );
    setSowDailogDescription(
      `${currentMember.first_name} will not going to have authority to access an Admin functions.`
    );
    setShowDailogMessage("Remove");
    setMakeAdminConfirm(true);
  };

  const handleRemoveClicked = async (currentMember) => {
    setActiveMember(currentMember);
    setRemoveMemberConfirm(true);
  };

  const handleLeaveClicked = async (currentMember) => {
    setActiveMember(currentMember);
    setLeaveTeam(true);
  };

  const makeAdmin = async () => {
    const currentMember = activeMember;
    setMakeAdminConfirm(false);

    try {
      await TeamService.postChangeUserRole(
        team?.id,
        currentMember?.id,
        changeRole
      );

      addToast("Member role has been changed ", { appearance: "success" });
    } catch (error) {
      console.log("Error: ", error);
    }

    setTeamMember({ ...currentMember, role_id: changeRole });
    setShowUserOptions(false);
  };

  const removeMember = async () => {
    const currentMember = activeMember;

    if (currentMember?.role_id === 2 && team?.members?.length > 1) {
      setSuperAdminLeaveTeam(true);
      return;
    }

    setRemoveMemberConfirm(false);

    try {
      await TeamService.removeTeamMember(team?.id, currentMember?.id);

      if (currentMember?.id === user?.id) {
        addToast("You have left the team ", { appearance: "error" });
        return;
      }

      addToast("Member has removed from the team. ", { appearance: "error" });
    } catch (error) {
      console.log("Error: ", error);
    }

    setTeamMember(null);
    setActiveMember(blankMember);
    setShowUserOptions(false);
  };

  const leaveTeam = async () => {
    const currentMember = activeMember;

    if (currentMember?.role_id === 2 && team?.members?.length > 1) {
      setSuperAdminLeaveTeam(true);
      return;
    }

    setLeaveTeam(false);

    try {
      if (team?.members?.length === 1) {
        await TeamService.deleteMyTeam(team.id);

        deleteTeam(team);
        history.push("/");
        return;
      }

      await TeamService.postTeamLeave(team?.id);

      if (currentMember?.id === user?.id) {
        addToast("You have left the team ", { appearance: "error" });
        return;
      }

      history.push("/");
    } catch (error) {
      console.log("Error: ", error);
    }

    setTeamMember(null);
    setActiveMember(blankMember);
    setShowUserOptions(false);
  };

  const myUserRole = () => {
    if (teamMember?.role_id === 3) {
      return "Admin";
    }

    if (teamMember?.role_id === 2) {
      return "Super Admin";
    }

    return "Member";
  };

  const closeUserOptionsDropDown = () => {
    setShowUserOptions(false);
  };

  const handleAdminModal = () => {
    setSelectAdminModal(true);
    setSuperAdminLeaveTeam(false);
    setShowUserOptions(false);
    setLeaveTeam(false);
  };

  const closeSelectAdminModal = () => {
    setSelectAdminModal(false);
    setActiveMember(blankMember);
    setShowUserOptions(false);
  };

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  return (
    <>
      {teamMember && (
        <div style={{ padding: 0 }}>
          <div className="super-admin">
            <Link
              style={{ color: "#575F6B", textDecoration:"none" }}
              to={`/profile/${teamMember?.id}`}
            >
              <div style={classes.userImageAndName}>
                <LazyLoadImage
                  onClickFunction={() => showUserProfile(teamMember?.id)}
                  image={teamMember?.avatar ?? UserDefaultAvatar}
                  key={`${teamMember?.full_name}`}
                  alt={`${teamMember?.full_name}`}
                  style={{ cursor: "pointer" }}
                />
                <div className="userinfo-team">
                  <h6 className="fs-16 fw-600 mb-0">
                    {member?.id === user?.id ? "You" : teamMember?.full_name}
                  </h6>
                  <small className="fs-12 color-light">{myUserRole()}</small>
                </div>
              </div>
            </Link>
            {(teamMember?.id === user?.id || teamMember?.role_id !== 2) &&
              ([2, 3].includes(team?.role_id) ||
                teamMember?.id === user?.id) && (
                <div className="delete-member" onClick={handleClickUserOptions}>
                  <FontAwesomeIcon
                    icon={faEllipsisV}
                    style={{ color: "#575F6B" }}
                  />
                  <CSSTransition
                    in={showUserOptions}
                    timeout={300}
                    unmountOnExit
                    classNames="dropdown-element"
                  >
                    <ClickAwayListener onClickAway={closeUserOptionsDropDown}>
                      <div style={classes.rootDropDown}>
                        <div style={classes.contentDropDown}>
                          <ul style={classes.contentList}>
                            {teamMember?.role_id !== 3 &&
                              team?.role_id !== 4 &&
                              teamMember?.role_id !== 2 && (
                                <li
                                  className="listContent"
                                  onClick={() => {
                                    handleAdminClicked(teamMember, 3);
                                  }}
                                >
                                  <div>
                                    {" "}
                                    <span style={classes.spanRoot}>
                                      Make Admin
                                    </span>
                                  </div>
                                </li>
                              )}
                            {[3, 2].includes(teamMember?.role_id) &&
                              teamMember?.id !== user?.id && (
                                <li
                                  className="listContent"
                                  onClick={() => {
                                    handleAdminClicked(teamMember, 4);
                                  }}
                                >
                                  <div>
                                    {" "}
                                    <span style={classes.spanRoot}>
                                      Dismiss as Admin
                                    </span>
                                  </div>
                                </li>
                              )}
                            {teamMember?.id === user?.id && (
                              <li
                                className="listContent"
                                onClick={() => {
                                  handleLeaveClicked(teamMember);
                                }}
                              >
                                <div>
                                  {" "}
                                  <span style={classes.spanRoot}>
                                    Leave Team
                                  </span>
                                </div>
                              </li>
                            )}
                            {teamMember?.id !== user?.id && (
                              <li
                                className="listContent"
                                onClick={() => {
                                  handleRemoveClicked(teamMember);
                                }}
                              >
                                <div>
                                  {" "}
                                  <span style={classes.spanRoot}>
                                    Remove from Team
                                  </span>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </ClickAwayListener>
                  </CSSTransition>
                </div>
              )}
          </div>
        </div>
      )}
      <Modal
        classNames={{ modalContainer: "modalContainer" }}
        open={makeAdminConfirm}
        showCloseIcon={false}
        onClose={() => setMakeAdminConfirm(false)}
      >
        <h4 style={classes.titleDailog}>{showDailogTitle}</h4>
        <h6 style={classes.headingDailog}>{showDailogDescription}</h6>
        <div style={classes.actionButton}>
          <Button
            buttonClass="small-btn me-2"
            onClick={() => {
              setMakeAdminConfirm(false);
              setActiveMember(blankMember);
              setShowUserOptions(false);
            }}
          >
            Cancel
          </Button>
          <Button onClick={makeAdmin} buttonClass=" small-accept-btn ">
            {showDailogMessage}
          </Button>
        </div>
      </Modal>
      <Modal
        classNames={{ modalContainer: "modalContainer" }}
        open={removeMemberConfirm}
        showCloseIcon={false}
        onClose={() => setRemoveMemberConfirm(false)}
      >
        <h4
          style={classes.titleDailog}
        >{`Remove ${activeMember.first_name} ${activeMember.last_name} from this team?`}</h4>
        <h6 style={classes.headingDailog}>
          This will remove the {activeMember.first_name}{" "}
          {activeMember.last_name}'s access to this team but will not remove the
          data and posts associated with the user. The user can be re-invited if
          needed.
        </h6>
        <div style={classes.actionButton}>
          <Button
            buttonClass="small-btn me-2"
            onClick={() => {
              setRemoveMemberConfirm(false);
              setActiveMember(blankMember);
              setShowUserOptions(false);
            }}
          >
            Cancel
          </Button>
          <Button onClick={removeMember} buttonClass=" small-reject-btn ">
            Remove
          </Button>
        </div>
      </Modal>

      <Modal
        classNames={{ modalContainer: "modalContainer" }}
        open={leaveTeamConfirm}
        showCloseIcon={false}
        onClose={() => setLeaveTeam(false)}
      >
        <h4 style={classes.titleDailog}>Leave Team</h4>
        <h6 style={classes.headingDailog}>
          Do you really want to leave the Team.
        </h6>
        <div style={classes.actionButton}>
          <Button
            buttonClass="small-btn me-2"
            onClick={() => {
              setLeaveTeam(false);
              setActiveMember(blankMember);
              setShowUserOptions(false);
            }}
          >
            Cancel
          </Button>
          <Button onClick={leaveTeam} buttonClass=" small-reject-btn ">
            Leave
          </Button>
        </div>
      </Modal>

      <Modal
        classNames={{ modalContainer: "modalContainer" }}
        open={superAdminLeaveTeam}
        showCloseIcon={false}
        onClose={() => setSuperAdminLeaveTeam(false)}
      >
        <h4 style={classes.titleDailog}>Super Admin Required!</h4>
        <h6 style={classes.headingDailog}>
          Please assign your role to another member before leaving the Team.
        </h6>
        <div style={classes.actionButton}>
          <Button
            buttonClass="small-btn me-2"
            onClick={() => {
              setSuperAdminLeaveTeam(false);
              setShowUserOptions(false);
            }}
          >
            Cancel
          </Button>
          <Button onClick={handleAdminModal} buttonClass=" small-accept-btn ">
            Proceed
          </Button>
        </div>
      </Modal>
      {showSelectAdminModal && (
        <SelectAdminModal
          user={user}
          currentMember={activeMember}
          showSelectAdminModal={showSelectAdminModal}
          closeSelectAdminModal={closeSelectAdminModal}
        />
      )}
    </>
  );
};
